import axiosApiInstance from '../../interceptors/axiosApiInstance';
import {BASE_URL} from '../config';

const ActionService = {
    getActionByFilter: async function (id) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/action/${id}/custom`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCustomActionsDetail: async function (params = {}) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/action/custom/details`, {params});
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getActionFieldConfiguration: async function (actionId) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/action/${actionId}/custom/field`);
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getCustomActionOutputs: async function (action_ids) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/action/custom/outputs`, {params: {action_ids}});
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getInputValueOptions: async function (id, app_connector_id, action_inputs) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/action/${id}/custom/input-value-options`, {
                params: {
                    app_connector_id,
                    action_inputs
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },
    getSysFieldOptions: async function (id, app_connector_id, input_keys, action_inputs) {
        try {
            const response = await axiosApiInstance.get(BASE_URL + `/action/${id}/custom/sys-field-options`, {
                params: {
                    app_connector_id,
                    input_keys,
                    action_inputs
                }
            });
            return response.data;
        } catch (error) {
            return error.response ? error.response.data : undefined;
        }
    },

};

export default ActionService;
